/**
 * Cookie-compatible auth helpers for Self Repair dashboard fetches.
 * Keep free of React so unit tests can load without the full page graph.
 */

/**
 * Axios config for Self Repair dashboard APIs.
 * Cookie session is enough — attach Bearer only when a client-readable token exists.
 */
export function buildAuthRequestConfig(token, timeoutMs) {
  const headers = {};
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return {
    headers,
    withCredentials: true,
    timeout: timeoutMs,
    // Treat 204 as a completed empty dashboard — never leave loading pending.
    validateStatus: (status) => (status >= 200 && status < 300) || status === 204,
  };
}

/** Auth gate for dashboard fetch — never requires localStorage/JWT token. */
export function resolveDashboardAuthGate({
  sessionReady,
  isAuthenticated,
  user,
  authState,
}) {
  if (!sessionReady || !isAuthenticated || !user) {
    if (authState === 'unauthenticated') {
      return { action: 'reject', reason: 'unauthenticated' };
    }
    return { action: 'wait', reason: 'session_pending' };
  }
  return { action: 'fetch', reason: 'authenticated' };
}

export function normalizeDashboardPayload(raw) {
  const data = (raw && typeof raw === 'object' && !Array.isArray(raw)) ? raw : {};
  const reportId = data.latest_report_id || data.report?.report_id || null;
  return {
    ...data,
    has_case: Boolean(reportId || data.has_case),
    empty: !reportId && !data.has_case,
  };
}
